window.addEventListener('resize', initEmployees);

export function initEmployees() {
  document.querySelectorAll('.c-employee').forEach(initEmployee);
}

function initEmployee(employee) {
  const employeeInfo = employee.querySelector('.c-info');
  if (!employeeInfo) return;

  const employeeNameHeight =
    employee.querySelector('.c-name')?.offsetHeight || 0;
  const employeeInfoHeight =
    getElementHeightWithoutPadding(employeeInfo) - employeeNameHeight;
  employeeInfo.style.setProperty('--info-height', `${employeeInfoHeight}px`);

  const toggleEmployee = () => toggleCollapsed(employee);

  // Remove existing event listeners
  employee.removeEventListener('mouseover', toggleEmployee);
  employee.removeEventListener('mouseout', toggleEmployee);

  // Add new event listeners
  employee.addEventListener('mouseover', toggleEmployee, { passive: true });
  employee.addEventListener('mouseout', toggleEmployee, { passive: true });
}

function getElementHeightWithoutPadding(element) {
  const style = window.getComputedStyle(element);
  const paddingTop = parseFloat(style.paddingTop);
  const paddingBottom = parseFloat(style.paddingBottom);
  return element.clientHeight - paddingTop - paddingBottom;
}

function toggleCollapsed(element) {
  const force = !element.classList.contains('collapsed');
  element.classList.toggle('collapsed', force);
}
